import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { basePort, headers } from "../module_auth/AuthService"
import { useNavigate } from "react-router-dom";
import parse from 'html-react-parser';
import { formatDate, sendGoogleAnalytics } from "./common/BaseUtil"
import { useLocation } from "react-router-dom";

export function Notice() {
    const location = useLocation();
    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("id")

    //공지사항상세
    const [noticeTitle, setNoticeTitle] = useState("");
    const [noticeContent, setNoticeContent] = useState("");
    const [hitCount, setHitCount] = useState("");
    const [updateAt, setUpdateAt] = useState("");
    //End 공지사항상세

    useEffect(() => {
        sendGoogleAnalytics(location.pathname)

        let url = basePort + '/get/notice/' + id
        fetch(url, 
          {method:'GET', headers,
            body:JSON.stringify()})
            .then(response => response.json())
            .then(response => {
                setNoticeTitle(response.noticeTitle)
                setNoticeContent(response.noticeContent)
                setHitCount(response.hitCount)
                setUpdateAt(response.updateAt)
          })
          .catch(error => console.log(error))
    }, []);

    let navigate = useNavigate();    
    function backToList() {
        let page = localStorage.getItem("page")
        let pageList = page == null ? 1 : page
        let url = "/notice_list?page=" + pageList;
        navigate(url);
    }

    return (
        <div>
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>공지사항</span></li>
                            <li class="breadcrumb-item"><span>내용</span></li>
                        </ol>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr></tr>
                                </thead>
                                <tbody>
                                    <tr style={{fontWeight: 'bold'}}>
                                        {/* <td>체불사업주 명단공개</td>
                                        <td>2023-04-24</td>
                                        <td>102</td> */}
                                        <td>{noticeTitle}</td>
                                        <td>{formatDate(updateAt)}</td>
                                        <td>{hitCount}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="container">
                        <div class="card">
                            <div class="card-body">
                            <p class="card-text">
                                        <span style={{color: '#222222'}}>
                                            {parse(noticeContent)}
                                        </span><br/><br/></p>
                            </div>
                        </div>
                    </div>
                    <div class="container d-flex d-sm-flex justify-content-center align-items-center justify-content-sm-center align-items-sm-center" style={{marginTop: '15px'}}>
                        <nav class="text-center d-flex d-md-flex justify-content-center justify-content-md-center justify-content-lg-center justify-content-xxl-center" style={{marginTop: '10px', textAlign: 'center'}}>
                            <ul class="pagination">
                                <li class="page-item text-center d-flex d-md-flex d-xxl-flex justify-content-center justify-content-md-center align-items-md-center" style={{textAlign: 'center'}} onClick={backToList}><a class="page-link">목록</a></li>
                            </ul>
                        </nav>
                    </div>
                </section>
            </main>
        </div>
    );
}